import React from 'react';

const SponsorOption = ({ name, id, imageUrl, imageAlt, handleSponsorRemoval, index }) => (
  <div className="mt-10">
    <div className="fflex-row-vc sponsor-name">
      <div className="fflex-row-vc">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={imageAlt}
            className="sponsor-image"
          />
        ) : (
          <div className="sponsor-empty-image" style={{ border: '1px solid #06a0dd' }} />
        )}
        <a
          href={`/admin/companies/${id}`}
          className="ml-10"
          target="_blank"
          rel="noopener noreferrer"
        >
          {name}
        </a>
      </div>
      <button
        type="button"
        className="btn-main btn-danger right"
        onClick={() => { handleSponsorRemoval(id); }}
      >
        <i className="fa fa-times" />
      </button>
      <input type="hidden" name={`event[sponsor_ids][${index}]`} value={id} />
    </div>
  </div>
);


export default SponsorOption;
